import React from 'react';

export default function LabelTemplate(str: string) {

  return function template(data: any) {
    return (
      <div style={{ position: 'relative', width: '100%', minHeight: '24px', overflow: 'visible' }}>
        <span style={{
          display: 'inline-block',
          width: '220px',
          maxWidth: '220px',
          position: 'absolute',
          left: 'calc(100% + 22px)',
          top: 0,
          whiteSpace: 'normal',
          textAlign: 'right',
          wordBreak: 'break-word',
          fontWeight: 600
        }}>
          <span style={{
            backgroundColor: '#cccccc',
          }}>
            {str}
          </span>
        </span>
        {data.text}
      </div>
    );
  };
}